import { remiApi } from "../api/remiApi";
import type { IdxConsentProfile } from "../config/idxConsentReceipts";

export const fetchIdxConsentProfile = async (
  organizationId: string,
  signal?: AbortSignal
): Promise<IdxConsentProfile> => {
  const { data } = await remiApi.get<IdxConsentProfile>(
    "/contacts/idx-consent-profile",
    { params: { organization_id: organizationId }, signal }
  );
  return data;
};
